import React from 'react'
import { ActionsMenu, Icon } from '@opallabs/lapidary'
import type { ContentCardOptionsMenuProps } from '../types'
import * as styles from './styles'

type DuplicationSubMenuProps = Pick<
  ContentCardOptionsMenuProps,
  'duplicatableChannels' | 'handleDuplication'
> & {
  label: string
}

export const DuplicationSubMenu: React.FC<DuplicationSubMenuProps> = ({
  duplicatableChannels,
  handleDuplication,
  label: triggerLabel,
}) => (
  <ActionsMenu.Sub>
    <ActionsMenu.SubTrigger>
      {triggerLabel}
      <Icon glyph="gem-chevron-e" />
    </ActionsMenu.SubTrigger>
    <ActionsMenu.Portal>
      <ActionsMenu.SubContent
        className="lapidary-content-card-duplication-sub-menu"
        css={{ maxBlockSize: 288 }}
        searchable={true}
        style={{ zIndex: 9999 }}
      >
        {duplicatableChannels.map((channel) => (
          <ActionsMenu.Item
            key={channel.id}
            onSelect={() => handleDuplication(channel.id)}
            css={{ display: 'flex', columnGap: 8 }}
            /* Prevent items from stealing focus from search when hovering */
            onPointerLeave={(e) => e.preventDefault()}
            onPointerMove={(e) => e.preventDefault()}
            onPointerOut={(e) => e.preventDefault()}
          >
            {channel.imageUrl ? (
              <div css={styles.imageContainer}>
                <img
                  alt={channel.label}
                  css={styles.imageStyles}
                  src={channel.imageUrl}
                />
              </div>
            ) : (
              <Icon
                glyph={`gem-channel-${
                  channel.iconName === 'website' ? 'web' : channel.iconName
                }-filled`}
                styleOverrides={{
                  icon: styles.iconStyles(channel.iconColor),
                }}
              />
            )}
            {channel.label}
          </ActionsMenu.Item>
        ))}
      </ActionsMenu.SubContent>
    </ActionsMenu.Portal>
  </ActionsMenu.Sub>
)
